/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPatternLock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 5a3 3 0 0 1 5.83-1h1.34a3.001 3.001 0 0 1 5.66 0h1.34a3.001 3.001 0 1 1 1.62 3.746l-3.044 3.044a3 3 0 0 1-3.956 3.956L7.746 17.79c.03.069.058.139.083.21h1.342a3.001 3.001 0 0 1 5.658 0h1.342a3.001 3.001 0 1 1 0 2h-1.342a3.001 3.001 0 0 1-5.658 0H7.829a3.001 3.001 0 1 1-1.454-3.667l2.958-2.959a3 3 0 0 1 4.042-4.042l2.958-2.958A2.966 2.966 0 0 1 16.17 6h-1.342A3.001 3.001 0 0 1 9.17 6H7.829A3.001 3.001 0 0 1 2 5zm10-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm10-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0zM5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPatternLock as PatternLock };
